import React, {Component} from 'react';
import './styles.scss';

import strings from '../../strings';
import {Howl} from 'howler';
import nosound from '../../assets/nosound.mp3';

class ReadyButton extends Component {
	constructor(props) {
		super(props);

		this.state = {isReady: false, hideButton: false};
	}

	toggleReady = () => {
		const isReady = !this.state.isReady;
		const {isAdultTest} = this.props;

		this.setState({
			isReady,
		});
		if (isAdultTest) {
			this.setState({
				hideButton: true,
			});
		}
		//Tell parent about this state change if callback is set.
		if (this.props.onReadyChange) this.props.onReadyChange(isReady);
	};

	onClick = () => {
		if (this.props.onClick) this.props.onClick();
		this.toggleReady();

		new Howl({src: nosound}).play();
	};

	render() {
		const {isReady, hideButton} = this.state;
		const {isAdultTest} = this.props;
		let currentText = strings.youAreReady;
		if (!isReady) {
			if (isAdultTest) {
				currentText = strings.startAdult;
			} else if (!this.props.isSpoonerism) {
				currentText = strings.ready;
			} else {
				currentText = 'Start';
			}
		}

		return (
			<>
				{!hideButton && (
					<div
						className={`ReadyButton${isReady ? ' ready' : ''}`}
						onClick={this.onClick}
					>
						{currentText}
					</div>
				)}
			</>
		);
	}
}

export default ReadyButton;
